import type { SiteChromeKey } from '../../lib/siteChromeCopy';

/** Non-empty after trim — clear contact field → CTA hidden. */
export function hasContactValue(value: string): boolean {
  return value.trim().length > 0;
}

/** Chrome key for the shared next-step helper in the copy column (third-party). */
export function resolveDirectNextChromeKey(
  hasMessenger: boolean,
  hasCall: boolean,
): SiteChromeKey {
  if (hasMessenger && hasCall) {
    return 'reservationNextDirect';
  }
  if (hasCall && !hasMessenger) {
    return 'reservationNextCall';
  }
  return 'reservationNextMessenger';
}
